import { Api } from 'utils';

class TestService {
	
	static get = async (params?: any) => Api.createResponse('client/test',params);
	static send = async (params?: any) => Api.createResponse('client/test/send',params);

}

export default TestService;